const UserInfluenceReport = {

	visual: {
		icon: "va-icon fa fa-user-secret",
		title: "User influence Report",
		desc: "Analysis of specific users influence base on followers and retweet count total."
	},

	binding: [
		{"user_relation_screen_name": "string","label":"Screen name"},
		{"user_relation_limit":"number","label":"Limit"},
		{"user_relation_min_influence":"number","label":"Min Influence ( 2000 'followers' + 500 'retweets' = 2500 'influance')"},
		{"created_at_from":"date","label":"Status | Retweet craeted from"},
		{"created_at_to":"date","label":"Status | Retweet created to"}
	],

	query:`
		MATCH 
			(a:Account {screen_name: ':user_relation_screen_name'})-[r1:POSTED | :RETWEETED | :MENTIONED_BY]->(s:Status) 
		WHERE 
			date(s.created_at) >= date(':created_at_from') AND date(s.created_at) <= date(':created_at_to')
		WITH 
			a, s  MATCH (a2:Account)-[:RETWEETED]->(sm:Status)  
		WHERE 
			s.id = sm.retweeted_id 
		AND 
			date(sm.created_at) >= date(':created_at_from') AND date(sm.created_at) <= date(':created_at_to') 
		WITH 
			a, a2, COUNT(sm) as sm_count, collect(distinct a2) as accs  
		WITH 
			a, a2, sm_count, accs, (a2.followers_count * sm_count) as n  
		WHERE
			n >= :user_relation_min_influence
		UNWIND 
			accs as acc  CALL apoc.create.vRelationship(a,'RELATED_VIA_RETWEET',{count:sm_count, influence: n}, acc) 
			YIELD rel  
		RETURN a, rel, acc, n   
			ORDER BY (CASE n WHEN null THEN {} ELSE n END) 
		DESC  LIMIT 
			:user_relation_limit
	`,

	config:{
		console_debug:false,
		labels: {
			"Account": {
				"caption": "screen_name",
				"size": "followers_count"
			}
		},
		relationships: {
			"RELATED_VIA_RETWEET": {
				"thickness": "count",
				"caption": false,
				"community": "influence"
			}
		},
	}
	
}

export default UserInfluenceReport;
